import * as React from 'react';
import { formatLanguage } from './formatter';

interface CodeState {
  isMultiLanguage: boolean;
  languages: string[];
  active: string;
}

const initialState = {
  isMultiLanguage: false,
  languages: [],
  active: '',
};

const CodeContext = React.createContext<{
  state: CodeState;
  setState: React.Dispatch<React.SetStateAction<CodeState>>;
}>({ state: initialState, setState: () => {} });

export const CodeBlock = ({ children }: { children: React.ReactNode }) => {
  const [state, setState] = React.useState(initialState);

  React.useEffect(() => {
    if (!state.active && state.languages.length) {
      setState((s) => ({ ...s, active: s.languages[0] }));
    }
  }, [state.languages, state.active]);

  return (
    // @ts-ignore
    <CodeContext.Provider value={{ state, setState }}>
      <div className="multi-language">
        {state.languages?.length ? (
          <div className="language-picker">
            {state?.languages.map((l, i) => (
              <button
                key={i}
                className={l === state.active ? 'active' : undefined}
                onClick={() => setState((s) => ({ ...s, active: l }))}>
                {formatLanguage(l)}
              </button>
            ))}
          </div>
        ) : null}
      </div>
      {children}
    </CodeContext.Provider>
  );
};

export function useCodeBlock() {
  const {
    state: { active, isMultiLanguage, languages },
    setState,
  } = React.useContext(CodeContext);

  function registerLanguage(l: string) {
    if (!languages || !languages?.includes(l)) {
      setState((s) => ({
        ...s,
        isMultiLanguage: languages ? true : false,
        languages: [...(s?.languages ?? []), l],
      }));
    }
  }

  return {
    isMultiLanguage,
    languages,
    registerLanguage,
    active,
  };
}
